import { ChatMessage, SeenEntry } from "./ChatMessage";
import { Message } from "./Message";

export class FileMessage extends ChatMessage {
  fileName: string;
  filePath: string;
  fileType: string;
  text: string;
  repliedTo: Message | FileMessage | null;
  
  constructor(
    text: string,
    fileName: string,
    filePath: string,
    fileType: string,
    messageId: string,
    isOwner: boolean,
    chatRoomId: string,
    senderName: string,
    repliedTo: Message | FileMessage | null,
    sentTime: Date | null,
    deliveredTime: Date | null,
    arrivalTime: Date | null,
    seenTimes: SeenEntry[],
    editedTime: Date | null,
    deletedTime: Date | null,

  ) {
    super(messageId, isOwner, chatRoomId, senderName, sentTime, deliveredTime, seenTimes, editedTime, deletedTime, arrivalTime);
    this.fileName = fileName;
    this.filePath = filePath;
    this.fileType = fileType;
    this.text = text;
    this.repliedTo = repliedTo;
  }

  toMap(): { [key: string]: any } {
    return {
      ...super.toMap(),
      message: this.text,
      repliedTo: this.repliedTo,
      fileName: this.fileName,
      filePath: this.filePath,
      fileType: this.fileType,
    };
  }

  static fromMap(map: { [key: string]: any }): FileMessage {
    const isOwner = map["isOwner"] === 1;
    
     let seenTimes: SeenEntry[] = [];
  if (map["seenTimes"]) {
    if (typeof map["seenTimes"] === 'string') {
      try {
        const parsedSeenTimes = JSON.parse(map["seenTimes"]);
        seenTimes = parsedSeenTimes.map((entry: any) => ({
          name: entry.name,
          time: new Date(entry.time)
        }));
      } catch (error) {
        console.warn("Failed to parse seenTimes string:", error);
        seenTimes = [];
      }
    } else if (Array.isArray(map["seenTimes"])) {
      seenTimes = map["seenTimes"].map((entry: any) => ({
        name: entry.name,
        time: new Date(entry.time)
      }));
    } else {
      console.warn("seenTimes is neither string nor array:", typeof map["seenTimes"]);
      seenTimes = [];
    }
  }

    return new FileMessage(
      map["message"] || "",
      map["fileName"] || "",
      map["filePath"] || "",
      map["fileType"] || "",
      map["messageId"],
      isOwner,
      map["chatRoomId"],
      map["sender"] || map["senderName"],
      map["repliedTo"],
      map["sentTime"] ? new Date(map["sentTime"]) : null,
      map["deliveredTime"] ? new Date(map["deliveredTime"]) : null,
      map["arrivalTime"] ? new Date(map["arrivalTime"]) : null,
      seenTimes,
      map["editedTime"] ? new Date(map["editedTime"]) : null,
      map["deletedTime"] ? new Date(map["deletedTime"]) : null,
    );
  }
}